import React, {Component} from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import {navigateTo} from "gatsby-link"
import { catalogs, prefix, deprefix, langFromPath } from '../../i18n-config'
import { connect } from "react-redux"
import * as actions from '../../actions/nav'
import * as uiActions from '../../actions/ui'
import Scroll from '../Scroll'
import './style.css'
import SvgEl from "./../SvgEl";
import LOGO from "./../../img/logos";
/*import Sound from 'react-sound';*/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FaVolumeUp, FaVolumeOff } from '@fortawesome/free-solid-svg-icons'
import config from './../../../meta/config';

const bowser = require('bowser');

const breakpoint = {
    mobile: 727,
    ipadV: 768,
    ipadH: 1024,
    nav: 1087,
    desktop:1200,
    large:1400
};

class Nav extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showModal: this.props.modalVisible,
      classNav: this.props.location === '/' ? 'no-shrink' : 'shrink',
      scrollY: 0,
      isActive: 0,
      isActiveClass: '',
      lang: this.props._lang
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleMusic = this.toggleMusic.bind(this);
    this.langChangeToDe = this.langChangeToDe.bind(this);
    this.langChangeToEn = this.langChangeToEn.bind(this);
    this.langChangeToRu = this.langChangeToRu.bind(this);
    this.screenWidth = this.screenWidth.bind(this);
  }

  componentDidMount() {

    switch(this.props._lang){
      case 'de' :
      this.props.langDe();
      break;
      case 'en' :
      this.props.langEn();
      break;
      case 'ru' :
      this.props.langRu();
      break;
    }


    const browser = bowser.getParser(window.navigator.userAgent);
    const browserData = browser.parsedResult.browser;

  //  window.soundManager.setup({ debugMode: false });
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.screenWidth);

    //Detect is safari, if not play sound automatically without user interaction.
    var isBrowser = browserData.name ;
  /*  if(isBrowser != 'Safari'){
      this.toggleMusic();
    }else{
      console.log('Sound off - Safari does not accept to play sound without user interaction.')
    }
*/

  }




  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.screenWidth);
  }

  toggleMenu(event){

    if(this.state.isActive === 0) {
      this.setState({
        isActive: 1,
        isActiveClass: 'is-active'

      });
    }
  else if(this.state.isActive === 1) {
      this.setState({
        isActive: 0,
        isActiveClass: ''

      });
    }

  }

  handleScroll(event) {
    let scrollTop = event.target.scrollingElement.scrollTop;

        if( scrollTop > 30 && scrollTop < 35 ){
          //console.log(scrollTop);
        }

    this.setState({
      classNav: 'shrink',
      scrollY: scrollTop

    });

      if( scrollTop < 30 &&  this.props.location === '/' ){
        this.setState({
          classNav: 'no-shrink',
          scrollY: scrollTop
        });

      }
}

  toggleMusic() {
    this.props.music === true ? this.props.musicPause() : this.props.musicPlay();
  }

  langChangeToDe() {
    this.props.langDe();
    this.setState({lang:'de'});
    navigateTo(prefix('de') + deprefix(this.props.location))
  }
  langChangeToEn() {
    this.props.langEn();
    this.setState({lang:'en'});
    navigateTo(prefix('en') + deprefix(this.props.location))

  }
  langChangeToRu() {
    this.props.langRu();
    this.setState({lang:'ru'});
    navigateTo(prefix('ru') + deprefix(this.props.location))

  }
  // set the window width in the store
  screenWidth() {
    this.props.getScreenWidth();
  }


  render () {
    var screenWidth = this.props.screenWidth
    var _lang = this.props._lang
    var _urls = []
    var _labels = []
    var _links = this.props.links
    var links = []
    // transform object in array to get on eposition manually calling a certain key
    for (var key in _links) {
    links.push(_links[key])
    }


    return (
      <div>

      {/*<Sound
      url="/msk/msk_001.mp3"
      playStatus={this.props.music === true ? Sound.status.PLAYING : Sound.status.STOPPED }
      loop={true}
      />*/}



      <ul className="overNav navBar">
    {/*  <li>
      <button className="volume" onClick={this.toggleMusic}>{this.props.music === true ? <FontAwesomeIcon icon="volume-up" /> : <FontAwesomeIcon icon="volume-off" /> }</button></li> */}
    { /* <li><button onClick={this.props.lang !== 'en' ? this.langChangeToEn : null}>EN</button></li>
      <li><button onClick={this.props.lang !== 'de' ? this.langChangeToDe : null}>DE</button></li> */}
    {/*  <li>
      <Link onClick={() => this.langChangeToDe}className='is-hidden-mobile langSel' to={'/de' }>
              <img className={"_de_" + _lang } src="/img/de.gif" alt="de"/>
      </Link>
      </li>
      <li>
      <Link onClick={() => this.langChangeToEn}className='is-hidden-mobile langSel' to={'/'}>
              <img className={"_en_" + _lang } src="/img/en.gif" alt="en"/>
      </Link>
      </li><li>
      <Link onClick={() => this.langChangeToRu}className='is-hidden-mobile langSel' to={'/ru'}>
              <img className={"_ru_" + _lang } src="/img/ru.gif" alt="ru"/>
      </Link>
      </li> */}



        <li><a target="_blank" href={config.insta}><span className="_circle"><i className="fab fa-instagram"></i></span></a></li>
        <li><a target="_blank" href={config.fb}><span className="_circle"><i className="fab fa-facebook-f"></i></span></a></li>



      </ul>

      <Scroll onScroll={(e)=> {this.handleScroll}} type="id" element={'tt'}>
      <div id="tt"></div>
      </Scroll>
      <nav className={"navbar is-fixed-top " + this.state.classNav } aria-label="main navigation">

          <div className="navbar-brand is-logo is-expanded">

          <Link to="/" className="logo headlineSvg">
              <SvgEl svg={LOGO.MAIN} />
          </Link>

              <button onClick={this.toggleMenu} className={'button navbar-burger ' + this.state.isActiveClass} data-target='navMenu'>
                  <span/>
                  <span/>
                  <span/>
              </button>
          </div>
          <div className={"navbar-menu " + this.state.isActiveClass} id="navMenu">

              <div className={"navbar-start " + this.state.classNav}>


<span className="divider mleft"/>

<Link key={"link-" + 0} onClick={this.toggleMenu} className=" navbar-item" to={'/' + _lang + '/' + links[0].u }>
   {links[0].l}
</Link>
<Link key={"link-" + 1} onClick={this.toggleMenu} className="navbar-item" to={'/' + _lang + '/' + links[1].u }>
   {links[1].l}
</Link>
<Link key={"link-" + 2} onClick={this.toggleMenu} className="navbar-item" to={'/' + _lang + '/' + links[2].u }>
   {links[2].l}
</Link>

{/* {this.props.links.map( (link, index) => (

   link.u !== 'i' ? <Link key={"link-" + index} onClick={this.toggleMenu} className="navbar-item is-hoverable flex-end" to={'/' + _lang + '/' + link.u }>
      {link.l}
  </Link>
  :
  ''
  )

)} */}

                {/* <Link onClick={this.langChangeToRu} className="is-hidden-tablet navbar-item is-hoverable flex-end" to="/ru">
                    RU
                  </Link>
                  <Link onClick={this.langChangeToEn} className="is-hidden-tablet navbar-item is-hoverable flex-end" to="/en">
                    EN
                  </Link>
                  <Link onClick={this.langChangeToDe} className="is-hidden-tablet navbar-item is-hoverable flex-end" to="/">
                    DE
                  </Link>
                  */}
                  <p>&nbsp;</p>
              </div>
              {this.props.screenWidth <= breakpoint.nav ?
              <div className={"socialIconsPhone socialIconsPhone-" + this.state.isActiveClass }>
              {/* <a target="_blank" href={config.pint}><span className="_circle"><i className="fab fa-pinterest"></i></span></a> */}
              <a target="_blank" href={config.inst}><span className="_circle"><i className="fab fa-instagram"></i></span></a>
              <a target="_blank" href={config.fb}><span className="_circle"><i className="fab fa-facebook-f"></i></span></a>

           </div>
           :
           ''
         }
              <div className="navbar-end">
              </div>
          </div>
      </nav>



    </div>
    );
  }
  }


Nav.propTypes = {
  lang: PropTypes.string,
  music: PropTypes.bool.isRequired,
  screenWidth: PropTypes.number.isRequired,
  screenHeight: PropTypes.number.isRequired,
  langDe: PropTypes.func.isRequired,
  langEn: PropTypes.func.isRequired,
  musicPlay: PropTypes.func.isRequired,
  musicPause: PropTypes.func.isRequired,
  getScreenWidth: PropTypes.func.isRequired
}

const mapStateToProps = ({ lang, music, langDe, langEn, musicPlay, musicPause, screenWidth, screenHeight, getScreenWidth }) => {
  return {  lang, music, screenWidth, screenHeight }
}

const mapDispatchToProps = dispatch => {
  return {
    langDe: () => dispatch(actions.lang_de()),
    langEn: () => dispatch(actions.lang_en()),
    langRu: () => dispatch(actions.lang_ru()),
    musicPlay: () => dispatch(actions.music_play()),
    musicPause: () => dispatch(actions.music_pause()),
    getScreenWidth: () => dispatch(uiActions.screenResize(window.innerWidth, window.innerHeight))
   }
}

const ConnectedNav = connect(mapStateToProps, mapDispatchToProps)(Nav)

export default ConnectedNav



// WEBPACK FOOTER //
// ./src/components/ConnectedNav/index.js